
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.096 2.904a6.5 6.5 0 11-9.192 9.192 6.5 6.5 0 019.192-9.192zM15.64 11A8.795 8.795 0 0022 17.367L7.133 30.603a1.618 1.618 0 01-2.193-.064l-.65-.65-.444.446a.755.755 0 01-1.067 0l-.066-.066a.754.754 0 010-1.065l.445-.446-.697-.697a1.616 1.616 0 01-.063-2.192L15.64 11zm-.703 8.78a1.213 1.213 0 10-1.715-1.714l-3.167 3.167a1.213 1.213 0 101.716 1.715l3.166-3.167z"}})])
          )
        }
      }
    